import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import { axios } from '@/library/axios';
import type { BaseResponse } from '@/types';

export const livePricee = () => {
  return axios<LivePriceData, BaseResponse<LivePriceData>, void>({
    url: '/dg/prices',
    method: 'get',
    params: {
      time: 'LATEST',
    },
    // headers : headers
  });
};

export const initialLiveData = {
  blockId: '',
  discountAppliedForSale: false,
  blockIdExpireAt: '',
  purchaseTax: 0,
  buyGoldRate: 0,
  saleTax: 0,
  discountAppliedForBuy: false,
  saleGoldRateAfterDiscount: 0,
  buyGoldRateAfterDiscount: 0,
  id: '',
  saleGoldRate: 0,
};

export const useLivePrice = () => {
  const [livePriceData, setLivePriceData] =
    useState<LivePriceData>(initialLiveData);
  const { data, isLoading, isSuccess, refetch } = useQuery({
    queryKey: [
      'livePrice',
      {
        time: 'LATEST',
      },
    ],
    queryFn: () => livePricee(),
    useErrorBoundary: false,
  });

  useEffect(() => {
    const resultData = data?.data.data || initialLiveData;
    setLivePriceData(resultData);
  }, [data]);

  return {
    livePriceData,
    isLoading,
    isSuccess,
    refetch,
  };
};

export type LivePriceData = {
  blockId: string;
  discountAppliedForSale: boolean;
  blockIdExpireAt: string;
  purchaseTax: number;
  buyGoldRate: number;
  saleTax: number;
  discountAppliedForBuy: Boolean;
  saleGoldRateAfterDiscount: number;
  buyGoldRateAfterDiscount: number;
  id: string;
  saleGoldRate: number;
};
